import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=613cc7bd&scoped=true"
import script from "./Website.vue?vue&type=script&lang=js"
export * from "./Website.vue?vue&type=script&lang=js"
import style0 from "./Website.vue?vue&type=style&index=0&id=613cc7bd&prod&scoped=true&lang=css"
import style1 from "./Website.vue?vue&type=style&index=1&id=613cc7bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613cc7bd",
  null
  
)

export default component.exports